import { useCallback } from "react";
import useFetch from "hooks/useFetch";
import { getFetchOptions } from "utils/fetch";

/**
 * Single fetch of an upload's persisted search tags — timing is driven by the SearchTagsReady push plus a one-shot
 * fallback. onTags fires only for a non-empty result; a 404/error/empty result must leave the existing Keywords untouched.
 */
export const useSearchTagFetch = () => {
	const { execute } = useFetch();

	const fetchSearchTags = useCallback((storedName, onTags) => {
		if (!storedName) {
			return;
		}
		execute(`/api/v3/Upload/Zip/SearchTags?storedName=${encodeURIComponent(storedName)}`, getFetchOptions({ method: "GET" }), (data, error) => {
			const tags = !error ? (data?.searchTags ?? data?.SearchTags ?? "") : "";
			if (tags) {
				onTags(tags);
			}
		});
	}, [execute]);

	return { fetchSearchTags };
};
